import React from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {userConst} from "../../user/userConsts";

const PreLoginRoute = ({component: Component, userAuthStatus, prevLocation, ...rest}) => (
    <Route

        {...rest}
        render={props => {
            let authStatus = (userAuthStatus === userConst.AUTH_STATUS_AUTHORIZED);
            let uiContent;
            if (authStatus) {
                uiContent = (<Redirect to={{pathname: '/'}}/>);
            } else {
                uiContent = (<Component {...props} prevLocation={prevLocation}/>);
            }
            return uiContent;
        }
        }
    />
);

PreLoginRoute.propTypes = {};

const mapStateToProps = state => ({
    userAuthStatus: state.userState.userAuthStatus,
    prevLocation: state.appState.prevLocation
});

export default connect(mapStateToProps)(PreLoginRoute);
